/** shared labels/colours for the welfare admin pages (kept identical to the household welfare card) */
export const DIMENSIONS = ["สุขภาพ", "ความเป็นอยู่", "การศึกษา", "รายได้", "การเข้าถึงบริการรัฐ"];

export const DIMENSION_STYLE = {
  "สุขภาพ": { color: "#a12424", background: "#fcebeb" },
  "ความเป็นอยู่": { color: "#1f4f7a", background: "#e6f0f9" },
  "การศึกษา": { color: "#5b3fa0", background: "#efe9fb" },
  "รายได้": { color: "#1f6b45", background: "#e6f5ec" },
  "การเข้าถึงบริการรัฐ": { color: "#8a5a00", background: "#fdf3df" },
};

export const LEVEL_LABEL = { household: "ครัวเรือน", member: "รายบุคคล" };
export const GROUP_LABEL = {
  house: "แบบสอบถามครัวเรือน",
  member: "แบบสอบถามสมาชิก",
  cwd: "แบบสอบถามเด็กพิการ",
  neet: "แบบสอบถามเด็ก NEETs",
  household_derived: "ค่าคำนวณระดับครัวเรือน",
  custom: "กำหนดเอง",
};
export const GROUP_FOR_LEVEL = { household: ["house", "household_derived", "custom"], member: ["member", "cwd", "neet", "custom"] };

export const ACTION_LABEL = {
  need_flag: "ขึ้นเป็นปัญหา (และเสนอสวัสดิการ)",
  should_screen: "เสนอสวัสดิการให้เจ้าหน้าที่คัดกรอง",
  eligible: "มีสิทธิ์ได้รับสวัสดิการ",
};
export const ACTION_SHORT = { need_flag: "ปัญหา", should_screen: "คัดกรอง", eligible: "มีสิทธิ์" };

export const SEVERITY_LABEL = { urgent: "แก้ไขเร่งด่วน", monitor: "ติดตามการช่วยเหลือ" };
export const SEVERITY_STYLE = {
  urgent: { color: "#CE3131", background: "#fcebeb", border: "1px solid #f2c9c9" },
  monitor: { color: "#B36B00", background: "#fdf3df", border: "1px solid #f0dcae" },
};
export const SEVERITY_COLOR = { urgent: "#CE3131", monitor: "#F78B00" };

export const CONFIDENCE_LABEL = { high: "สูง", medium: "ปานกลาง", low: "ต่ำ" };

export const OP_LABEL = {
  eq: "เท่ากับ", ne: "ไม่เท่ากับ", in: "เป็นหนึ่งใน", not_in: "ไม่ใช่", contains: "มีตัวเลือก",
  gt: "มากกว่า", gte: "มากกว่าหรือเท่ากับ", lt: "น้อยกว่า", lte: "น้อยกว่าหรือเท่ากับ",
  exists: "มีคำตอบ", is_empty: "ไม่มีคำตอบ",
};
export const OPS_NO_VALUE = ["exists", "is_empty"];
export const OPS_ARRAY_VALUE = ["in", "not_in"];

export const QUESTIONNAIRE_LABEL = {
  household: "ครัวเรือน", member: "สมาชิก", neets: "เด็ก NEETs", cwd: "เด็กพิการ",
  member_identity: "ข้อมูลบุคคล", derived: "ค่าคำนวณ",
};

export const CATALOG_LEVEL_LABEL = { household: "ครัวเรือน", person: "รายบุคคล", unknown: "ไม่ระบุ" };
export const BENEFIT_TYPE_LABEL = { cash: "เงินสด/เงินอุดหนุน", service: "บริการ", in_kind: "สิ่งของ", mixed: "หลายรูปแบบ", loan: "สินเชื่อ", other: "อื่น ๆ" };
/** target-group vocabulary used by the seeded catalog (free text is still allowed) */
export const TARGET_GROUPS = ["All", "เด็ก", "วัยเรียน", "NEETs", "ผู้ใหญ่วัยทำงาน", "ผู้สูงอายุ", "คนพิการ", "หญิงตั้งครรภ์", "ผู้ป่วย"];

export const isProblemRule = (r) => !!r && (r.then?.action === "need_flag" || r.then?.flag === "missing_entitlement");

/** tab order follows the work: define problems once (1), then keep their welfare up to date every year (2) */
export const WELFARE_PAGES = [
  { name: "welfare-rules", label: "1. คำถาม → ปัญหา 5 มิติ", hint: "ตั้งครั้งเดียว" },
  { name: "welfare-mapping", label: "2. ปัญหา → สวัสดิการ", hint: "ปรับทุกปี" },
  { name: "welfare-catalog", label: "รายการสวัสดิการ" },
  { name: "welfare-settings", label: "ตั้งค่าและประวัติ" },
];
